import { Action } from '@ngrx/store';
import { Event } from '../models/event';

export enum TrackingActionTypes {
  Enqueue = '[Tracking] Enqueue Events'
}

export class Enqueue implements Action {
  readonly type = TrackingActionTypes.Enqueue;
  constructor(public payload: Event[]) {}
}

export type TrackingActions = Enqueue;
